/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: *management-units*.main.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog>Management Units Component
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Fragment } from "react";
import $ from "jquery";
import Detail from "./Detail";
import Edit from "./Edit";
import Table from "./Table";
import CreateBudget from "./modals/createBudget";
import CreateGrootboeknummer from "./modals/createGrootboeknummer";
import RowDeleteModal from "../../modal/rowDelete";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import * as CommonFunctions from "./functions/commonFunctions";
import { Switch, Route } from "react-router-dom";

class Financial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    // ColumnList.forEach(function (item) {
    //   if (item.name == "catalog>budget") {
    //     window.$catalog_area_columnList = item["column-list"];
    //   }
    // });

    window.$catalog_area_columnList = ColumnList.find(
      (x) => x.name === "catalog>budget"
    )["column-list"];

    var asd = "";
    /*** EKRANIN HERHANGİ BİRYERİNE TIKLANINCA POPUP KALDIRMAK İÇİN KULLANILAN FONKSİYON ***/
    $(document)
      .unbind("mouseup")
      .mouseup(function (e) {
        var popup = $("#myPopup");
        if (
          !$("div.popup").is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length === 0
        ) {
          $("#myPopup").html("");
          var popup = document.getElementById("myPopup");
          $("#myPopup").removeClass("show");
        }
      });

    $(document).on("click", ".area-catalog-action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$catalog_area_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
  }

  render() {
    const match = `${this.props.match.url}/${String(
      this.props.location.pathname.split("/")[2]
    )}`;
    return (
      <div className="border p-3 br5 full-width" id="border-mid">
        <Fragment>
          <Switch>
            <Route
              exact
              path={match}
              render={(props) => <Table {...props} />}
            />
            <Route
              path={`${match}/edit/:rowId`}
              render={(props) => <Edit {...props} />}
            />
            <Route
              path={`${match}/detail/:rowId`}
              render={(props) => <Detail {...props} />}
            />
          </Switch>
        </Fragment>
        {/* <Table {...this.props} />
        <Detail />
        <Edit /> */}

        <CreateBudget />
        <CreateGrootboeknummer />
        <RowDeleteModal
          id="budget-mappen_beheren_delete_modal"
          handleDelete={CommonFunctions.rowsHandleDelete}

          // buttonId="area-rows-delete-modal"
        />
      </div>
    );
  }
}

export default Financial;
